interface CardProps {
	children: React.ReactNode;
	className?: string;
}

const Card = ({ children, className = '' }: CardProps) => (
	<div className={`bg-white rounded-xl shadow-sm ${className}`}>{children}</div>
);

export { Card };
